// WebFoxx Academy Production Build Refresh: 2026-07-26
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { queryClient } from './lib/queryClient';
import { AuthProvider } from './context/AuthProvider';
import { AppearanceProvider } from './context/AppearanceProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initPerformance } from './lib/firebase';
import { NotificationProvider } from './context/NotificationContext';
import { ToastContainer } from './components/notifications/ToastContainer';

// Firebase Performance Monitoring (no-op unless REACT_APP_FIREBASE_* is set).
initPerformance();

if (process.env.NODE_ENV === 'production') {
  window.__WEBFOXX_BUILD__ = '2026-07-26-cache-fix';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppearanceProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <ErrorBoundary>
              <NotificationProvider>
                <App />
                <ToastContainer />
              </NotificationProvider>
            </ErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </AppearanceProvider>
  </React.StrictMode>
);
